import React from 'react'
import CreateRecipeContainer from '../Container/RecipeCreate/CreateRecipeContainer'

const CreateRecipe = () => {
  return <CreateRecipeContainer/>
}

export default CreateRecipe